import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X, Plus } from "lucide-react";
import { toast } from "sonner";

/** Admin list of reasons shown in the Lost / Not Interested outcome dropdown. */
export default function LostReasonsCard() {
  const { config, refreshConfig } = useAuth();
  const [items, setItems] = useState([]);
  const [add, setAdd] = useState("");
  useEffect(() => { setItems(config?.lost_reasons || []); }, [config]);
  const save = async (next) => {
    try { const { data } = await api.put("/settings/lost-reasons", { items: next }); setItems(data.items); toast.success("Lost reasons saved"); refreshConfig?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 mt-6 shadow-sm" data-testid="lost-reasons-card">
      <h3 className="font-heading font-bold text-[#312E81]">Lost Reasons</h3>
      <p className="text-xs text-slate-500 mb-3">Shown when a counselor picks Lost or Not Interested as the call outcome.</p>
      <div className="flex flex-wrap gap-2 mb-3">
        {items.map((r) => (
          <span key={r} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-rose-50 text-rose-700 text-xs border border-rose-100" data-testid={`lost-reason-${r.replace(/\s+/g, "-").toLowerCase()}`}>
            {r}<button onClick={() => save(items.filter((x) => x !== r))} className="hover:text-rose-900" data-testid={`lost-reason-remove-${r.replace(/\s+/g, "-").toLowerCase()}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
      <form className="flex gap-2 max-w-md" onSubmit={(e) => { e.preventDefault(); if (add.trim()) { save([...items, add.trim()]); setAdd(""); } }}>
        <Input value={add} onChange={(e) => setAdd(e.target.value)} placeholder="New reason, e.g. Chose distance education" data-testid="lost-reason-input" />
        <Button type="submit" className="bg-[#4F46E5] hover:bg-[#4338CA]" data-testid="lost-reason-add-btn"><Plus className="w-4 h-4 mr-1" /> Add</Button>
      </form>
    </div>
  );
}
